import { graphql, useStaticQuery } from "gatsby"
import useRoutePath from "./useRoutePath"

type Route = NonNullable<Queries.DatoLandingPageRoutesQuery["datoCmsWebsite"]>["rootRoute"]

const useProductLandingPagePath = () => {
  function findProductLandingPagePath(landingPageId: string, map: Record<string, string>) {
    // console.debug("Finding Product Landing Page URL path for landing page ID", landingPageId, map)

    const routeOriginalId = map[landingPageId]

    return getRoutePath(routeOriginalId)
  }

  function addToMap(route: Route) {
    if (!route) {
      return
    }
    if (route.page?.["originalId"]) {
      map[route.page["originalId"]] = route.originalId
    }
    if (route.treeChildren) {
      route.treeChildren.map(addToMap)
    }
  }

  const getRoutePath = useRoutePath()

  const data = useStaticQuery<Queries.DatoLandingPageRoutesQuery>(graphql`
    fragment DatoCmsRouteFragment on DatoCmsRoute {
      originalId
      page {
        ... on DatoCmsProductLandingPage {
          originalId
        }
      }
    }
    query DatoLandingPageRoutes {
      datoCmsWebsite(locale: "en") {
        rootRoute {
          ...DatoCmsRouteFragment
          treeChildren {
            ...DatoCmsRouteFragment
            treeChildren {
              ...DatoCmsRouteFragment
              treeChildren {
                ...DatoCmsRouteFragment
                treeChildren {
                  ...DatoCmsRouteFragment
                  treeChildren {
                    ...DatoCmsRouteFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const routeTree = data?.datoCmsWebsite?.rootRoute

  if (!routeTree) {
    console.error("Empty route tree in useProductLandingPagePath()")
    return () => undefined
  }

  // create a map of productPageId => routeId
  const map: Record<string, string> = {}
  addToMap(routeTree)

  return (landingPageId: string) => findProductLandingPagePath(landingPageId, map)
}
export default useProductLandingPagePath
